module.exports = __webpack_public_path__ + "static/snow-monkey-37f69b18e9251f7a34a9a758bdc14863.png";